import ChangePassword from "../pages/ChangePassword/ChangePassword";
import AdminProfile from "../pages/ProfileManage/AdminProfile";
import Analytics from "../pages/AnalyticData/Analytics";
import ApproveAuction from "../pages/Products/ApproveAuction";
import AuditLogs from "../pages/LogsTrack/AuditLogs";
import Brand from "../pages/BrandManage/Brand";
import Category from "../pages/CategoryManage/Category";
import AboutUsContent from "../pages/CMSPages/AboutUsContent";
import FAQ from "../pages/CMSPages/FAQ";
import FAQNL from "../pages/CMSPages/FAQNL";
import HowItWorks from "../pages/CMSPages/HowItWorks";
import NewsLetterContent from "../pages/CMSPages/NewsLetterContent";
import HomeSlides from "../pages/CMSPages/HomepageHeroSlides/HomeSlides";
import Contacts from "../pages/Queries/Contacts";
import DisputeDetails from "../pages/Orders/DisputeDetails";
import ItemListing from "../pages/Products/ItemListing";
import NewsLetter from "../pages/NewsLetter/NewsLetter";
import OrderDetails from "../pages/Orders/OrderDetails";
import Orders from "../pages/Orders";
import Payments from "../pages/Payments/Payments";
import Staff from "../pages/StaffManage";
import AddEditStaff from "../pages/StaffManage/addEditStaff";
import UserManagement from "../pages/UserManagement";
import AddEditUserManagement from "../pages/UserManagement/AddEditUserManagement";
import UserDetails from "../pages/UserManagement/userDetails";
import Notifications from "../reduxData/Notifications/Notifications";
import { MODULES } from "./modules";
import SizesManagement from "../pages/Sizes/SizesManagement";
import LedgerListing from "../pages/Orders/LedgerListing";
import BulkUploaded from "../pages/Products/BulkUploaded";
import ReturnDetail from "../pages/Orders/ReturnDetail";
import BulkUpdatedDetail from "../pages/Products/BulkUpdatedDetail";
import QueryDetail from "../pages/Queries/QueryDetail";
import DocumentsList from "../pages/CMSDocuments/DocumentsList.js";
import DocumentForm from "../pages/CMSDocuments/DocumentForm.js";
import DocumentDetail from "../pages/CMSDocuments/DocumentDetail.js";
import VersionHistory from "../pages/CMSDocuments/VersionHistory.js";
import ContentHub from "../pages/CMSDocuments/ContentHub";
import KnowledgeBaseList from "../pages/KnowledgeBase/KnowledgeBaseList";
import ArticleForm from "../pages/KnowledgeBase/ArticleForm";
import FinanceDocumentCentre from "../pages/FinanceDocuments/FinanceDocumentCentre";

export const ROUTE_CONFIG = [
    { path: "/", element: <Analytics />, module_name: MODULES.ANALYTICS_DASHBOARD },
    { path: "/profile", element: <AdminProfile />, module_name: MODULES.PROFILE },
    { path: "/change-password", element: <ChangePassword />, module_name: MODULES.PASSWORD },
    { path: "/users", element: <UserManagement />, module_name: MODULES.USERS },
    { path: "/user/:id", element: <UserDetails />, module_name: MODULES.USERS },
    { path: "/addUser", element: <AddEditUserManagement />, module_name: MODULES.USERS },
    { path: "/editUser/:id", element: <AddEditUserManagement />, module_name: MODULES.USERS },
    { path: "/item-listing", element: <ItemListing />, module_name: MODULES.PRODUCTS },
    { path: "/item-details/:id", element: <ApproveAuction />, module_name: MODULES.PRODUCTS },
    { path: "/notifications", element: <Notifications />, module_name: MODULES.NOTIFICATIONS },
    { path: "/orders", element: <Orders />, module_name: MODULES.ORDERS },
    { path: "/returns", element: <Orders />, module_name: MODULES.RETURNS },
    { path: "/return/:id", element: <ReturnDetail />, module_name: MODULES.RETURNS },
    { path: "/disputes", element: <Orders />, module_name: MODULES.DISPUTES },
    { path: "/order/:id", element: <OrderDetails />, module_name: MODULES.ORDERS },
    { path: "/payments", element: <Payments />, module_name: MODULES.PAYMENTS },
    { path: "/finance/documents", element: <FinanceDocumentCentre />, module_name: MODULES.PAYMENTS },
    { path: "/logs", element: <AuditLogs />, module_name: MODULES.LOGS_TRACKING },
    { path: "/newsletters", element: <NewsLetter />, module_name: MODULES.NEWSLETTER },
    { path: "/queries", element: <Contacts />, module_name: MODULES.QUERIES },
    { path: "/query/:id", element: <QueryDetail />, module_name: MODULES.QUERIES },
    { path: "/disputedetail/:id", element: <DisputeDetails />, module_name: MODULES.DISPUTES },
    { path: "/category", element: <Category />, module_name: MODULES.CATEGORIES },
    { path: "/sizes", element: <SizesManagement />, module_name: MODULES.SIZES },
    { path: "/bulk_upload", element: <BulkUploaded />, module_name: MODULES.BULK_UPLOAD },
    { path: "/bulk_upload/:id", element: <BulkUpdatedDetail />, module_name: MODULES.BULK_UPLOAD },
    { path: "/brand", element: <Brand />, module_name: MODULES.BRAND },
    { path: "/staff", element: <Staff />, module_name: MODULES.STAFFS },
    { path: "/staff/:id", element: <AddEditStaff />, module_name: MODULES.STAFFS },
    { path: "/staff/add", element: <AddEditStaff />, module_name: MODULES.STAFFS },
    { path: "/home-slides", element: <HomeSlides />, module_name: MODULES.CMS },

  // { path: "/badge", element: <PointsSystem /> },
  // { path: "/awards", element: <AwardsSystem /> },
  { path: "/leadger", element: <LedgerListing />, module_name: MODULES.CATEGORIES },
  { path: "/staff", element: <Staff />, module_name: MODULES.STAFFS },
  { path: "/staff/:id", element: <AddEditStaff />, module_name: MODULES.STAFFS },
  { path: "/staff/add", element: <AddEditStaff />, module_name: MODULES.STAFFS },
  { path: "/home-slides", element: <HomeSlides />, module_name: MODULES.CMS },
  { path: "/cms/content", element: <ContentHub />, module_name: MODULES.CMS },
  { path: "/cms/knowledge-base", element: <KnowledgeBaseList />, module_name: MODULES.CMS },
  { path: "/cms/knowledge-base/add", element: <ArticleForm />, module_name: MODULES.CMS },
  { path: "/cms/knowledge-base/:id/edit", element: <ArticleForm />, module_name: MODULES.CMS },
  { path: "/cms/documents", element: <DocumentsList />, module_name: MODULES.CMS },
  { path: "/cms/documents/create", element: <DocumentForm />, module_name: MODULES.CMS },
  { path: "/cms/documents/:id", element: <DocumentDetail />, module_name: MODULES.CMS },
  { path: "/cms/documents/:id/versions", element: <VersionHistory />, module_name: MODULES.CMS},
  { path: "/cms/documents/:id/new-version", element: <DocumentForm newVersion />, module_name: MODULES.CMS },
  { path: "/cms-pages/newsletter", element: <NewsLetterContent />, module_name: MODULES.CMS },
  { path: "/cms-pages/about-us", element: <AboutUsContent />, module_name: MODULES.CMS },
  { path: "/cms-pages/faq", element: <FAQ />, module_name: MODULES.CMS },
  { path: "/cms-pages/how-it-works", element: <HowItWorks />, module_name: MODULES.CMS },
  { path: "/cms-pages-nl/faq-nl", element: <FAQNL />, module_name: MODULES.CMS },
];
